import { useQuery } from '@tanstack/react-query';
import { fetchJobs, type JobsFilters } from '../api/jobs';

export const jobsQueryKey = (filters: JobsFilters) => ['jobs', filters] as const;

export function useJobsQuery(filters: JobsFilters) {
  return useQuery({
    queryKey: jobsQueryKey(filters),
    queryFn: () => fetchJobs(filters),
    placeholderData: (previousData) => previousData,
    staleTime: 1000 * 30,
    retry: 2,
    retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
  });
}
